/**
 * useRealizationsState — la fermeture de l'écran « Activités terminées », et ce que sa barre de
 * recherche a retenu.
 *
 * La fiche d'une activité est montée par le pont. Le rechargement passe par `useRealizationsData`.
 */
import { useMemo, useReducer } from "react"
import { useNavigation } from "@react-navigation/native"

import { EMPTY_ACTIVITY_SEARCH } from "../../../formatters/activitySearchFormatter"
import { type UIActivitySearch } from "../../../types"

type Action = { type: "SET_SEARCH"; search: UIActivitySearch }

function reducer(_state: UIActivitySearch, action: Action): UIActivitySearch {
    return action.search
}

export function useRealizationsState() {
    const navigation = useNavigation<{
        canGoBack: () => boolean
        goBack: () => void
        replace: (name: string) => void
    }>()
    const [search, dispatch] = useReducer(reducer, EMPTY_ACTIVITY_SEARCH)

    const actions = useMemo(
        () => ({
            close: () => {
                if (navigation.canGoBack()) navigation.goBack()
                else navigation.replace("menu")
            },
            setSearch: (next: UIActivitySearch) => dispatch({ type: "SET_SEARCH", search: next }),
        }),
        [navigation]
    )

    return { search, actions }
}
